/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { OpprettSkjemaResponseTo } from '../models/opprett-skjema-response-to';


/**
 * Skjema-API
 */
@Injectable({
  providedIn: 'root',
})
export class SkjemaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation opprettSkjema
   */
  static readonly OpprettSkjemaPath = '/skjema';

  /**
   * Oppretter et nytt skjema og returnerer den genererte id-en.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opprettSkjema()` instead.
   *
   * This method doesn't expect any request body.
   */
  opprettSkjema$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<OpprettSkjemaResponseTo>> {

    const rb = new RequestBuilder(this.rootUrl, SkjemaService.OpprettSkjemaPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OpprettSkjemaResponseTo>;
      })
    );
  }

  /**
   * Oppretter et nytt skjema og returnerer den genererte id-en.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opprettSkjema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opprettSkjema(params?: {
  },
  context?: HttpContext

): Observable<OpprettSkjemaResponseTo> {

    return this.opprettSkjema$Response(params,context).pipe(
      map((r: StrictHttpResponse<OpprettSkjemaResponseTo>) => r.body as OpprettSkjemaResponseTo)
    );
  }

}
